module.exports = __webpack_public_path__ + "static/media/logo-ufsc.8df4b7dd.svg";